import { actualAttributes, actualAttributesT, cameraPositions } from './../../utils/constants';
import { TYPE_REDUCER } from '../../utils/constants';
import priceId from '../../../products.json';
import priceAdditional from '../../../productsAdditional.json';
import { getMockAttributes } from '../../utils/threekitMocks';
export type modalName =
  | 'arStep1'
  | 'itemHint'
  | 'MailComponent'
  | 'MailSent'
  | 'loader';
export type modalListT = Record<modalName, boolean>;

export type initialStateT = {
  configInfo: {
    isShortId: boolean;
  };
  modalState: {
    modalInfo: null;
    modalList: modalListT;
  };
  attributes: {};
  priceInfo: {};
  priceAdditional: {};
};

// Quantity overrides per attribute (for cart / pricing purposes)
const QUANTITY_MAP: Record<string, number> = {
  Tire: 4,
  Wheels: 4,
  Mirror: 2,
  'Hood Catcher': 2,
};

/**
 * Build initial Redux attributes from the API-loaded mock data.
 * Falls back to an empty object when called before initAttributesFromAPI().
 */
export function buildInitialAttributesFromAPI(): Record<string, any> {
  const mocks = getMockAttributes();
  const result: Record<string, any> = {};

  console.log('[buildInitialAttributesFromAPI] Building initial attributes from API mocks...');

  for (const [attrName, attr] of Object.entries(mocks) as [string, any][]) {
    if (!attr || !attr.values || attr.values.length === 0) continue;

    // Use the mock attribute's current default (respects DEFAULT_OVERRIDES)
    const isAsset = attr.type === 'Asset';
    const currentDefault = isAsset ? attr.defaultValue?.assetId : attr.defaultValue;
    const defaultVal = attr.values.find((v: any) =>
      isAsset ? v.assetId === currentDefault : v.value === currentDefault
    ) ?? attr.values[0];
    const label = defaultVal?.label ?? 'Default';
    const id = defaultVal?.metadata?._id;
    const priceForId = id ? (priceId as any)[id]?.price ?? 0 : 0;

    result[attrName] = {
      activeItem: label,
      defaultItem: label,
      cameraPosition: (cameraPositions as any)[attrName] ?? undefined,
      price: priceForId,
      ...(id ? { activeItemId: id } : {}),
      shopInfo: { quantity: QUANTITY_MAP[attrName] ?? 1 },
    };

    console.log(`[buildInitialAttributesFromAPI] ${attrName}:`, {
      label,
      id,
      priceForId,
      fullAttr: result[attrName]
    });
  }

  console.log('[buildInitialAttributesFromAPI] Final result:', result);
  return result;
}

// Initial attributes — empty until API loads, then replaced via SET_ATTRIBUTES
const mockInitialAttributes: Record<string, any> = {};


const initialState: initialStateT = {
  configInfo: {
    isShortId: false,
  },
  modalState: {
    modalInfo: null,
    modalList: {
      arStep1: false,
      itemHint: false,
      MailComponent: false,
      MailSent: false,
      loader: false,
    },
  },
  attributes: mockInitialAttributes,
  priceInfo: priceId,
  priceAdditional: priceAdditional,
};

console.log('[Settings initialState] priceInfo loaded from products.json:', {
  priceInfoKeys: Object.keys(priceId),
  samplePrices: Object.entries(priceId).slice(0, 5),
  has21996: '21996' in priceId,
  price21996: priceId['21996']
});

const Settings = (state: any = initialState, action: any) => {
  switch (action.type) {
    case TYPE_REDUCER.EXAMPLE_ACTION:
      return {
        ...state,
        example: action.payload,
      };
    case TYPE_REDUCER.SET_MODAL:
      return {
        ...state,
        modalState: {
          modalInfo: action.payload.info || null,
          modalList: {
            ...state.modalState.modalList,
            ...action.payload.list,
          },
        },
      };
    case TYPE_REDUCER.SET_ATTRIBUTES:
      console.log('[Redux SET_ATTRIBUTES] Replacing all attributes:', action.payload);
      return {
        ...state,
        attributes: action.payload,
      };
    case TYPE_REDUCER.SET_PRICE_INFO:
      console.log('[Redux SET_PRICE_INFO] Updating priceInfo:', action.payload);
      return {
        ...state,
        priceInfo: action.payload,
      };
    case TYPE_REDUCER.SET_IS_SHORT_ID:
      return {
        ...state,
        configInfo: {
          ...state.modalState.configInfo,
          isShortId: action.payload,
        },
      };
    case TYPE_REDUCER.SET_ACTIVE_ITEM:
      const { name, data }: any = action.payload;
      console.log(`[Redux SET_ACTIVE_ITEM] ${name}:`, {
        previousState: state.attributes[name],
        incomingData: data,
        mergedResult: { ...state.attributes[name], ...data }
      });
      return {
        ...state,
        attributes: {
          ...state.attributes,
          [name]: {
            ...state.attributes[name],
            ...data,
          },
        },
      };
    default:
      return state;
  }
};
export default Settings;
